<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Agents summary ({{data.group}})</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex>
    <div fxLayout="column" fxFlexFill>
      <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
        <mat-spinner></mat-spinner>
      </div>
      <div fxFlex="auto" fxFlexFill class="table-container">
        <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table"
                   matSort matSortActive="extension" matSortDirection="desc" matSortDisableClear>

          <ng-container matColumnDef="extension">
            <mat-header-cell *matHeaderCellDef mat-sort-header="_id">Extension</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-mini-fab class="no-shadow button-32 agents-summary" color="primary"
                      (click)="showCallLogsDetails(row)" matTooltip="View Agent Call Logs">
                <mat-icon>person</mat-icon>
              </button>
              {{row._id}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="totalLoggedIn">
            <mat-header-cell *matHeaderCellDef mat-sort-header="totalLoggedIn">Total Logged In</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.totalLoggedInFormatted}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="totalAnswered">
            <mat-header-cell *matHeaderCellDef mat-sort-header="totalAnswered">Total Answered</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.totalAnswered}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="totalMissed">
            <mat-header-cell *matHeaderCellDef mat-sort-header="totalMissed">Calls Not Accepted</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.totalMissed}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="avgDurationRing">
            <mat-header-cell *matHeaderCellDef mat-sort-header="avgDurationRing">Avg. Ring Time</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.avgDurationRingFormatted}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="avgDurationTalk">
            <mat-header-cell *matHeaderCellDef mat-sort-header="avgDurationTalk">Avg. Talk Time</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.avgDurationTalkFormatted}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="durationRing">
            <mat-header-cell *matHeaderCellDef mat-sort-header="durationRing">Total Ring Time</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.durationRingFormatted}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="durationTalk">
            <mat-header-cell *matHeaderCellDef mat-sort-header="durationTalk">Total Talk Time</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.durationTalkFormatted}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="surveys">
            <mat-header-cell *matHeaderCellDef>Survey Results, Avg.</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div *ngFor="let survey of row.surveys">
                <div>
                  <span>{{survey.accountName}}</span>
                  <span style="padding-left: 5px">({{survey.avg | number:'1.2-2'}})</span>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
        </mat-table>
      </div>
      <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onProcessConfirm()" [promiseBtn]="onConfirm">Export</button>
  </mat-dialog-actions>
</div>
